import React from 'react'
import Form from './form/Form'
import { Field } from 'redux-form'
import InputField from './form/InputField'
import TextareaField from './form/TextareaField'

export const ContactForm = props => {
	const { isHome, successMessage, errorMessage, t } = props
	const colors = isHome
		? {
			labelColor: 'bud',
			borderColor: 'white',
			bgBtn: 'albes'
		}
		: {
			labelColor: 'black',
			borderColor: 'finch',
			bgBtn: 'finch'
		}
	return <Form {...props}>
		<Field
			name='name'
			id='name'
			type='text'
			label={`${t('contactForm.nameLabel')}*`}
			labelClassName={`u-text--${colors.labelColor} u-margin-right-small u-weight--normal`}
			component={InputField}
			className=''
			formGroupClassName={`c-form-field-panel u-border-bottom--${colors.borderColor}-20 u-margin-bottom u-padding-vertical-small`}
		/>
		<Field
			name='email'
			id='email'
			type='email'
			label={`${t('contactForm.emailLabel')}*`}
			labelClassName={`u-text--${colors.labelColor} u-margin-right-small u-weight--normal`}
			component={InputField}
			className=''
			formGroupClassName={`c-form-field-panel u-border-bottom--${colors.borderColor}-20 u-margin-bottom u-padding-vertical-small`}
		/>
		<Field
			name='message'
			id='message'
			label={`${t('contactForm.messageLabel')}*`}
			labelClassName={`u-text--${colors.labelColor} u-margin-right-small u-weight--normal`}
			component={TextareaField}
			className=''
			formGroupClassName={`c-form-field-panel u-border-bottom--${colors.borderColor}-20 u-margin-bottom u-padding-vertical-small`}
            rows='3'
		/>
		{ successMessage && <div className='u-text--apple u-text--center'>{successMessage}</div> }
		{ errorMessage && <div className='u-text--monza u-text--center'>{errorMessage}</div> }
		<div className={`o-block u-center-on-mobile${ isHome ? ' o-block--left' : ''}`}>
			<button className={`c-btn c-btn--${colors.bgBtn} u-text--normal u-margin-vertical`} type='submit'>{t('contactForm.submitBtn')} &#8594;</button>
		</div>
	</Form>
}



// WEBPACK FOOTER //
// ./src/components/ContactForm.js